/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import IEnergyManagementProps, {
  ECarbonCartAt
} from '../IEnergyManagementProps';
import { Grid } from '@scuf/common';
import './EnergyManagementSiteDashboardContent.scss';
import './EmaasSiteDashboardCommonTable.scss';
import CarbonEmissionGraphKPI from '../CarbonEmissionGraphKPI/CarbonEmissionGraphKPI';
import { shouldComponentNotUpdateOnDateChange } from '../../shared/Utils/Utils';

const EMaaSEnergySiteDashboardGraphContent = React.memo(
  (props: IEnergyManagementProps) => {
    const { connectorConfig, requestContext } = props;

    return (
      <Grid className={`layout-grid`}>
        <Grid.Row className="layout-content-grid-row">
          <Grid.Column
            width={4}
            xsWidth={12}
            className="energyusage-kpi-card emaas-siteview-dashboard"
          >
            <CarbonEmissionGraphKPI
              connectorConfig={connectorConfig}
              requestContext={requestContext}
              carbonApiFor={ECarbonCartAt.siteLabel}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  },
  shouldComponentNotUpdateOnDateChange
);

export default EMaaSEnergySiteDashboardGraphContent;
